import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import { mensagemErro, nomePerfil } from "../../services/acesso";
import Logo from "../../assets/imgs/prospect_brasil.png";
import LogoBora from "../../assets/imgs/bora.png";
import "../Login/styles.css";

const CadastroConvite = () => {
    const { codigo } = useParams();
    const [convite, setConvite] = useState(null);
    const [erro, setErro] = useState("");
    const [name, setName] = useState("");
    const [telephone, setTelephone] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [loading, setLoading] = useState(false);
    const [concluido, setConcluido] = useState(false);

    useEffect(() => {
        api.get(`convite/${codigo}`)
            .then((result) => setConvite(result.data))
            .catch((e) => setErro(mensagemErro(e, "Convite inválido")));
    }, [codigo]);

    const cadastrar = async (event) => {
        event.preventDefault();
        if (!name) {
            toast.error("Informe o nome");
            return;
        }
        if (!password || password.length < 8) {
            toast.error("A senha precisa ter no mínimo 8 caracteres");
            return;
        }
        if (password !== passwordConfirmation) {
            toast.error("A confirmação da senha não confere");
            return;
        }
        setLoading(true);
        try {
            await api.post(`convite/${codigo}/cadastro`, {
                name,
                telephone,
                password,
                password_confirmation: passwordConfirmation,
            });
            setConcluido(true);
            toast.success("Cadastro realizado");
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível concluir o cadastro"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bodylogin">
            <form className="form_login" onSubmit={cadastrar}>
                <div className="logo-form-login">
                    <img src={Logo} width={200} alt="Prospect Brasil" />
                </div>
                <h2 style={{ textAlign: "center" }}>Cadastro</h2>
                {erro && <p style={{ color: "#c62828", textAlign: "center" }}>{erro}</p>}
                {convite && !concluido && (
                    <>
                        <p style={{ textAlign: "center" }}>
                            {convite.email}<br />
                            Perfil: {convite.perfil_nome || nomePerfil(convite.perfil)}
                        </p>
                        <Grid item style={{ paddingTop: 10 }}>
                            <TextField required label="Nome" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 16 }}>
                            <TextField label="Telefone" value={telephone} onChange={(e) => setTelephone(e.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 16 }}>
                            <TextField required type="password" label="Senha" value={password} onChange={(e) => setPassword(e.target.value)} helperText="Mínimo de 8 caracteres" fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 16 }}>
                            <TextField required type="password" label="Confirmar senha" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 24, display: "flex", justifyContent: "center" }}>
                            <Button variant="contained" color="primary" type="submit" disabled={loading}>Cadastrar</Button>
                        </Grid>
                    </>
                )}
                {concluido && (
                    <Grid item style={{ paddingTop: 16, textAlign: "center" }}>
                        <p>Cadastro realizado. Entre com o e-mail e a senha que você criou.</p>
                        <Button variant="contained" color="primary" onClick={() => { window.location.href = "/login"; }}>
                            Ir para o login
                        </Button>
                    </Grid>
                )}
            </form>
            <div className="logo-bora">
                <img src={LogoBora} width={200} alt="" />
            </div>
        </div>
    );
};

export default CadastroConvite;
